import Highway from '@dogstudio/highway';
import { browser } from '../util/browserInfo';
import 'objectFitPolyfill';

export default class Page extends Highway.Renderer {
  isEdge() {
    return browser.name === 'Microsoft Edge';
  }

  isIE() {
    return browser.name === 'Internet Explorer';
  }

  checkEdgeElems() {
    if (!this.isEdge()) return;

    const elems = document.querySelectorAll('.checkEdge');

    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.add('isEdge');
    }
  }

  checkIEElems() {
    if (!this.isIE()) return;

    const elems = document.querySelectorAll('.checkIE');

    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.add('isIE');
    }
  }

  isSafari() {
    return browser.name === 'Safari';
  }

  checkSafariElems() {
    if (!this.isSafari()) return;

    const elems = document.querySelectorAll('.checkSafari');

    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.add('isSafari');
    }
  }

  /**
   * NOTE: `this.props` is an object passed in
   * parameter when calling `super.onEnter()`
   * from a child Page
   *
   * @param {Boolean} props - An object with a `hasMap` key, if `true`, Google Map will init on this page
   *
   * @returns {void}
   */
  onEnter(props = {}) {
    this.view = this.wrap.lastElementChild;

    this.props = props;

    if (this.isEdge() || this.isIE()) objectFitPolyfill();

    this.checkEdgeElems();
    this.checkIEElems();
    this.checkSafariElems();
    this.scrollEnchor();
  }

  onEnterCompleted() {
    // this.parallax = new Parallax({
    //     parent: this.view,
    //     disableUnder: 768,
    //     willChange: true
    // })
  }

  onLeave() {}

  onLeaveCompleted() {
    this.parallax && this.parallax.destroy();
  }

  resize() {
    this.parallax && this.parallax.resize();
  }

  scroll() {}

  update() {
    this.parallax && this.parallax.render();
  }

  scrollEnchor() {
    const links = document.querySelectorAll('.link');

    Array.from(links).forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const href = link.dataset.href;
        const section = document.querySelector(href);

        if (section) {
          let screenPosition = window.scrollY;

          if (
            window.scrollY < section.offsetTop &&
            (this.isSafari() || this.isEdge())
          ) {
            const timer = setInterval(() => {
              window.scrollTo(screenPosition, screenPosition + 40);
              screenPosition += 40;

              if (
                window.scrollY >= section.offsetTop - 100 ||
                window.innerHeight + window.scrollY >=
                  document.body.offsetHeight
              ) {
                clearInterval(timer);
                screenPosition = 0;
              }
            }, 20);
          } else if (
            window.scrollY > section.offsetTop &&
            (this.isSafari() || this.isEdge())
          ) {
            const timer = setInterval(() => {
              window.scrollTo(screenPosition, screenPosition - 40);
              screenPosition -= 40;

              if (
                window.scrollY <= section.offsetTop - 100 ||
                window.scrollY <= 0
              ) {
                clearInterval(timer);
                screenPosition = 0;
              }
            }, 20);
          } else {
            window.scrollTo(screenPosition, section.offsetTop);
            console.log('chrome or firefox');
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/Page.js